import React from 'react';
import { NavLink } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';

type AdminSection = 'user-management' | 'listing-management' | 'data-management' | 'support-tickets';

const menuItems: { key: AdminSection; path: string; label: string; icon: string }[] = [
  { key: 'user-management', path: '/admin-panel/user-management', label: 'User Management', icon: 'fa-users' },
  { key: 'listing-management', path: '/admin-panel/listing-management', label: 'Listing Management', icon: 'fa-list' },
  { key: 'data-management', path: '/admin-panel/data-management', label: 'Data Management', icon: 'fa-database' },
  { key: 'support-tickets', path: '/admin-panel/support-tickets', label: 'Destek Talepleri', icon: 'fa-headset' },
];

const AdminSideMenu: React.FC = () => {
  return (
    <nav
      className="col-md-3 col-lg-2 d-md-block bg-dark sidebar collapse"
      style={{ minHeight: 'calc(100vh - 56px)' }}
    >
      <div className="position-sticky pt-3">
        <ul className="nav flex-column">
          {menuItems.map(({ path, label, icon }) => (
            <li key={path} className="nav-item">
              <NavLink
                className={({ isActive }) =>
                  `nav-link text-white ${isActive ? 'active bg-primary' : ''}`
                }
                to={path}
              >
                <i className={`fas ${icon} me-2`} />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default AdminSideMenu;
